import { TOP, BOTTOM, LEFT, RIGHT, BEFORE, AFTER } from 'layout-dnd-utils/constants';

// Drag types
export const dragTypes = {
  EXISTING_ITEM: 'EXISTING_ITEM',
  RESIZE_HANDLE: 'RESIZE_HANDLE'
};

// Drop target types
export const dropTypes = {
  PREPEND_ROW: 'PREPEND_ROW',
  APPEND_ROW: 'APPEND_ROW',
  INSERT_COLUMN_AFTER: 'INSERT_COLUMN_AFTER',
  INSERT_COLUMN_BEFORE: 'INSERT_COLUMN_BEFORE',
  INSERT_INTO_EMPTY_ROW: 'INSERT_INTO_EMPTY_ROW',
  INSERT_INTO_EMPTY_COLUMN: 'INSERT_INTO_EMPTY_COLUMN',
  INSERT_ROW_AFTER: 'INSERT_ROW_AFTER',
  INSERT_ROW_BEFORE: 'INSERT_ROW_BEFORE'
};
export const dropTargetLocations = {
  TOP,
  BOTTOM,
  LEFT,
  RIGHT,
  BEFORE,
  AFTER,
  INSIDE: 'INSIDE',
  SPLIT_ROW_BEFORE: 'SPLIT_ROW_BEFORE',
  SPLIT_ROW_AFTER: 'SPLIT_ROW_AFTER'
};

// Resize handle types
export const resizeHandleTypes = {
  RESIZE_HANDLE_LEFT: 'RESIZE_HANDLE_LEFT',
  RESIZE_HANDLE_RIGHT: 'RESIZE_HANDLE_RIGHT',
  RESIZE_HANDLE_BETWEEN: 'RESIZE_HANDLE_BETWEEN'
};

// Resize handle dimensions
export const resizeHandleDimensions = {
  HEIGHT_SCALE: 0.8,
  WIDTH: 10
};
export const MODULE_DRAG_HANDLE = 'MODULE_DRAG_HANDLE';
export const EMPTY_CONTAINER_DRAG_HANDLE = 'EMPTY_CONTAINER_DRAG_HANDLE';
export const COLUMN_DRAG_HANDLE = 'COLUMN_DRAG_HANDLE';
export const ROW_DRAG_HANDLE = 'ROW_DRAG_HANDLE';
export const TOPMOST_SECTION_ROW_DRAG_HANDLE = 'TOPMOST_SECTION_ROW_DRAG_HANDLE';
export const INSERT_NEW_SECTION_HANDLE = 'INSERT_NEW_SECTION_HANDLE';
export const OFFSCREEN_POSITION = {
  TOP: -1000,
  LEFT: -1000
};
export const DRAG_PREVIEW_HEIGHT_PX = 80;
export const DRAG_PREVIEW_WIDTH_PX = 80;
export const SCROLL_DURING_DRAG_AMOUNT = 50;

// Node position config keys
export const GLOBAL_GROUPS_CONFIG = 'GLOBAL_GROUPS_CONFIG';
export const GLOBAL_PARTIALS_CONFIG = 'GLOBAL_PARTIALS_CONFIG';
export const STATIC_MODULES_CONFIG = 'STATIC_MODULES_CONFIG';
export const POST_BODY_MODULES_CONFIG = 'POST_BODY_MODULES_CONFIG';
export const FLEX_COLUMN_MODULES_CONFIG = 'FLEX_COLUMN_MODULES_CONFIG';
export const NESTED_MODULES_IN_RTE_CONFIG = 'NESTED_MODULES_IN_RTE_CONFIG';
export const LAYOUT_SECTIONS_CONFIG = 'LAYOUT_SECTIONS_CONFIG';
export const ALL_NODE_POSITION_CONFIG_KEYS = [GLOBAL_GROUPS_CONFIG, GLOBAL_PARTIALS_CONFIG, STATIC_MODULES_CONFIG, FLEX_COLUMN_MODULES_CONFIG, LAYOUT_SECTIONS_CONFIG, POST_BODY_MODULES_CONFIG, NESTED_MODULES_IN_RTE_CONFIG];
export const LAYOUT_SECTION_HOVER_OVERLAY_COLORS = {
  DEFAULT_BACKGROUND: '#7fd1de',
  // Calypso Medium
  DEFAULT_OUTLINE: '#0091ae',
  // Calypso Dark
  UPDATED_OUTLINE: '#7fd1de',
  // Calypso Medium
  GLOBAL_GROUP_BACKGROUND: '#ff8f59',
  // Sorbet
  GLOBAL_GROUP_OUTLINE: '#ff8f59',
  // Sorbet
  EMBED_BACKGROUND: '#6a78d1',
  // Thunderdome
  EMBED_OUTLINE: '#6a78d1',
  // Thunderdome
  MODULE_WITHOUT_ACCESS_OUTLINE: '#f2545b',
  // Candy Apple
  RICH_TEXT_WITHOUT_ACCESS_BACKGROUND: '#f2545b',
  // Candy Apple
  RICH_TEXT_WITHOUT_ACCESS_OUTLINE: '#f2545b',
  // Candy Apple
  UNEDITABLE_DIAGONAL_BARS_ONE: '#7fd1de',
  // Calypso Medium
  UNEDITABLE_DIAGONAL_BARS_TWO: '#0091ae',
  // Calypso Dark
  REMOVE_MODULE_DIAGONAL_BARS_ONE: '#f2545b',
  // Candy Apple
  REMOVE_MODULE_DIAGONAL_BARS_TWO: '#d94c53' // Candy Apple Dark
};
export const FLEX_COLUMN_RGB_COLORS = {
  DROP_TARGET_BACKGROUND: 'rgb(240,246,248)',
  // '#f0f6f8'
  DROP_TARGET_BORDER: 'rgb(0,0,0)',
  // '#000000'
  DROP_TARGET_ON_HOVER_BACKGROUND: 'rgb(0,0,100, 0.5)',
  // '#000064' with 50% opacity
  DRAG_OVERLAY_BACKGROUND: 'rgb(229,245,248, 0.7)',
  // '#e5f5f8' with 70% opacity
  DRAG_OVERLAY_OUTLINE: 'rgb(0,164,189, 0.8)',
  // '#00a4bd' with 80% opacity
  DRAG_OVERLAY_FONT: 'rgb(0,164,189, 0.9)',
  // '#00a4bd' with 90% opacity
  DRAG_SURFACE_BACKGROUND: 'rgb(255,255,255,0.8)' // '#ffffff' with 80% opacity
};
export const Z_INDEX_MAX_LAYERS = {
  LEVEL_1: 2147483598,
  LEVEL_2: 2147483599,
  LEVEL_3: 2147483600,
  LEVEL_4: 2147483640,
  LEVEL_5: 2147483647
};